module.exports = __webpack_public_path__ + "static/media/alternative_2_big@x2.4c6e0437.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/alternative_2_big@x2.png
// module id = 538
// module chunks = 0